import React from "react";
import { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
/* import { FaRegSnowflake } from "react-icons/fa6";
import { TbChristmasTree } from "react-icons/tb";
import { SlPresent } from "react-icons/sl"; 
import { GiEasterEgg } from "react-icons/gi";
import { GiEggClutch } from "react-icons/gi";
import { IoIosSunny } from "react-icons/io";*/
import "./notification.css"

const Notification = () => {

    const [notificationOpen, closeNotification] = useState(true);

    useEffect(() => {
        const data = window.sessionStorage.getItem("notificationOpen");
        if (data !== null) closeNotification(JSON.parse(data))
    }, [])
    useEffect(() => {
        window.sessionStorage.setItem("notificationOpen", JSON.stringify(notificationOpen))
    }, [notificationOpen])

    return (
        <>
            {notificationOpen ?
                <div className="notification">
                    <button className="notificationButton" onClick={() => closeNotification((prev) => !prev)}>
                        <CloseIcon className="notificationIcon" />
                    </button>
                    <p>

                        {/* WINTERFERIEN
                        <b>Liebe Patientin,<br></br> lieber Patient,</b> <br></br><br></br>
                        unsere Praxis bleibt vom 23.12.24 - 02.01.25 geschlossen. <br></br>
                        Ab dem 06.01.25 sind wir wieder wie gewohnt für Sie erreichbar. <br></br><br></br>
                        Wir wünschen allen eine besinnliche Weihnachtszeit und einen guten Rutsch ins neue Jahr!<br></br><br></br>
                        <FaRegSnowflake className="notification_leaf"/>
                        <TbChristmasTree className="leaf"/>
                        <SlPresent className="notification_leaf2"/>
                        */}

                        {/* HERBSTFERIEN
                        <b>Liebe Patientin, lieber Patient,</b> <br></br><br></br>
                        wir befinden uns vom 14.10. - 24.10. im Urlaub. <br></br>
                        Ab dem 28.10. sind wir wieder wie gewohnt für Sie da. <br></br><br></br>
                        In dringenden Fällen wenden Sie sich bitte an unsere Vertretung:<br></br>
                        Frau Dana Kashua in Braunschweig<br></br><br></br>
                        Vielen Dank für Ihr Verständnis! <br></br>
                        <FaCanadianMapleLeaf className="notification_leaf"/>
                        <GiOakLeaf className="leaf"/>
                        <FaCanadianMapleLeaf className="notification_leaf2"/>
                        */}

                        {/*
                        <b>Liebe Patienten,</b> <br></br><br></br>
                        die Praxis bleibt am Donnerstag den 07.08 nachmittags geschlossen. Ab Montag <br></br>
                        den 11.08. sind wir wieder wie gewohnt für Sie da. <br></br><br></br>
                        <br></br>
                        */}

                        {/*
                        <GiEasterEgg className="notification_easteregg"/>
                        <GiEggClutch className="notification_easteregg3"/>
                        <GiEasterEgg className="notification_easteregg2"/>
                        */}

                        
                        <b>Liebe Patientinnen und Patienten,</b> <br></br><br></br>

                        Vom 27.07. bis 06.08. gelten geänderte Sprech- und Telefonzeiten.<br></br><br></br>
                        
                        Die Praxis ist in diesem Zeitraum täglich von 08:30 bis 13:30 Uhr erreichbar. Bereits vereinbarte Termine finden wie
                        geplant statt. Termine außerhalb dieser Zeiten erfolgen nach individueller Vereinbarung. <br></br><br></br>

                        Ihr Praxisteam
                       {/*
                       <IoIosSunny className="sun"/>
                       <IoIosSunny className="sun"/>
                       <IoIosSunny className="sun"/>
                        */}

                    </p>
                </div>
                :
                ''
            }
        </>
    )
}

export default Notification